<template>
  <CommonModal
    class="confirm-modal"
    title="温馨提示"
    :footer="null"
    :width="684"
    :maskClosable="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="confirm-modal-inner">
      <!-- <p class='modal-content'>新入驻商家请及时完成支付宝、微信进件，以便店铺正常运营。</p> -->
      <div class='modal-content'>
        请新入驻商家及时完成支付宝和微信进件，以便店铺正常运营。否则将无法上架商品售卖。
        <div class='content'>
          如已提交进件申请，可点击“查询进件状态”按钮，查看最新状态。
        </div>
      </div>
      <p class='confirm-modal-button-warp'>
        <a-button class="confirm-modal-button" :href="config.link" size='large' target='_blank' @click="onStart">去进件</a-button>
        <a-button class="confirm-modal-button" :href="config.link" size='large' target='_blank' type="primary" @click="onQuery">查询进件状态</a-button>
      </p>
    </div>
  </CommonModal>
</template>

<script>
  import { Button } from 'ant-design-vue'
  import CommonModal from '@/components/common-modal'

  export default {
    name: "confirm-modal",
    components: {
      CommonModal,
      [Button.name]: Button,
    },
    data() {
      return {
        config: {},
      }
    },
    async created() {
      // console.log(this.$attrs, this.$listeners)
    },
    methods: {
      close() {
        this.$emit('cancel')
      },
      onStart() {
        this.$emit('onStart')
      },
      onQuery() {
        this.$emit('onQuery')
      }
    }
  }
</script>

<style lang="scss" scoped>
.confirm-modal-inner{
  padding: 25px 40px;
  height: 290px;
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .modal-content{
    padding-left: 10px;
    font-size: 16px;
    // text-indent: 36px;
    line-height: 32px;
    .content{
      margin-top: 10px;
    }
  }
}
.confirm-modal-button-warp{
  display: flex;
  justify-content: center;
}
.confirm-modal-button{
  width: 180px;
  // height: 32px;
  line-height: 32px;
  // background: $primary-main;
  // color: #fff;
  // display: block;
  border-radius: 4px;
  &:nth-child(n+1){
    margin-left: 20px;
  }
}

</style>
